<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-user
          DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_id')" @enter="getDailyMember(true)" size="sm")
      .form-group.col-md-12.col-lg-12.col-xl-5.col-12.mb-1
        DateRangePicker(:value="date" @update="getData")
      .form-group.col-12.mb-1
        SubmitButton(
          icon="fa fa-search"
          :loading="loading"
          :text="$t('ui.search')"
          type="button"
          @click="getDailyMember(true)"
          variant="primary"
          size="sm"
        ).mr-2
        //- jsonToExcel(v-if="dailyMemberList.length > 0" mode="DailyWinloseOperator" tbl="tblList" :date="date")
  .card-body
    .row
      .col-12.mb-1
        h2.section-title.mt-0 {{ id }}
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12(style="max-height: 70vh; overflow: hidden;")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="10%" @click="sortOrder('account_id')")
                  span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  .float-right
                    i(:class="changeSortKey('account_id')")
                th.text-right(width="11%" @click="sortOrder('turnover')")
                  span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                  .float-right
                    i(:class="changeSortKey('turnover')")
                th.text-right(width="11%" @click="sortOrder('valid_turnover')")
                  span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                  .float-right
                    i(:class="changeSortKey('valid_turnover')")
                th.text-right(width="11%" @click="sortOrder('winlose')")
                  span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                  .float-right
                    i(:class="changeSortKey('winlose')")
                th.text-right(width="11%" @click="sortOrder('bet_count')")
                  span(:title="$t('ui.bet_count')") {{ $t('ui.bet_count') }}
                  .float-right
                    i(:class="changeSortKey('bet_count')")
            tbody.clusterize-content
              tr(v-if="dailyMemberList.length == 0")
                td(colspan="6").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in dailyMemberList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.account_id") {{ item.account_id }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                td.text-right
                  span.font-weight-bold(:title="item.bet_count") {{ item.bet_count }}
              tr(v-if="showTotal")
                td.text-right(colspan="2")
                  span.d-block {{ $t("ui.sub_total") }}
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                td.text-right
                  span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                td.text-right
                  span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                td.text-right
                  span.font-weight-bold.d-block(:title="subTotalBetCount") {{ subTotalBetCount }}
                  span.font-weight-bold(:title="grandTotalBetCount") {{ grandTotalBetCount }}                          

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    date: {
      type: Object,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    grandTotalList: [],
    dailyMemberList: [],
    currentPage: 1,
    totalRow: 0,
    searchID: "",
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalBetCount: 0,
    grandTotalBetCount: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "account_id",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() { },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDailyMember(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.date.endDate).diff(this.$moment(this.date.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.date.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.date.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getDailyMember(true);
    },
    getDailyMember: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.promotionSignupWinloseMemberUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.id,
          start_date: this.date.startDate,
          end_date: this.date.endDate,
          sort_type: this.sortType,
          sort_key: this.sortKey,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        if(this.searchID)
          json.member_id = this.searchID

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.statement.length > 0) {
                    this.showTotal = true;
                    response.data.ds.statement.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalBetCount = parseInt(this.subTotalBetCount) + parseInt(value["bet_count"]);                      
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalBetCount = response.data.ds.grand_total[0]["bet_count"];
                    }

                    this.dailyMemberList = response.data.ds.statement;
                    this.totalRow = response.data.ds.statement.length > 0 ? this.dailyMemberList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.dailyMemberList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.dailyMemberList = []
      this.totalRow = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalBetCount = 0
      this.grandTotalBetCount = 0      
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDailyMember(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getDailyMember();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>